import { Host, h } from '@stencil/core';
export class AibaWeatherBlock {
  constructor() {
    this.handleWeatherOnChange = async (event) => {
      var _a, _b;
      this.validationFieldValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
      if (this.handlers && this.handlers.handleValidationWeatherField) {
        const result = await this.handlers.handleValidationWeatherField((_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.value, 'postalCode');
        if (!result.details) {
          this.error = null;
          this.submitButtonDisabled = false;
        }
      }
    };
    this.handleWeatherOnKeyPress = () => {
      this.submitButtonDisabled = false;
    };
    this.handleWeatherOnBlur = (event) => {
      var _a;
      this.validationFieldValue = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
      if (this.validationFieldValue) {
        this.submitButtonDisabled = false;
      }
    };
    this.convertCamelCaseToTitleCase = (text) => {
      const result = text.replace(/([A-Z])/g, ' $1');
      return result.charAt(0).toUpperCase() + result.slice(1);
    };
    this.renderWeatherVariationsBlock = (weatherBlockData) => {
      var _a;
      return (weatherBlockData &&
        ((_a = weatherBlockData === null || weatherBlockData === void 0 ? void 0 : weatherBlockData.elements) === null || _a === void 0 ? void 0 : _a.map((element) => {
          var _a, _b;
          if (element && element['name'] === 'aiba-spinner' && this.loading)
            return h("aiba-spinner", Object.assign({}, element['data']));
          if (element && element['name'] === 'aiba-not-enable-form-block' && !this.enableForm && !this.invalidPostCode && ((_b = (_a = this.weatherData) === null || _a === void 0 ? void 0 : _a.weather) === null || _b === void 0 ? void 0 : _b.length) > 0)
            return (element &&
              element['data'] &&
              element['data']['elements'] &&
              element['data']['elements'].map((innerElement) => {
                var _a;
                if (innerElement && innerElement['name'] === 'aiba-hero-image')
                  return h("aiba-hero-image", Object.assign({}, innerElement['data']));
                if (innerElement && innerElement['name'] === 'aiba-right-block')
                  return (h("div", { class: "aiba-right-block-wrapper" }, (_a = innerElement === null || innerElement === void 0 ? void 0 : innerElement.data) === null || _a === void 0 ? void 0 : _a['elements'].map((rightBlockElement) => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
                    if (rightBlockElement && rightBlockElement['name'] === 'aiba-label-location')
                      return (h("aiba-label", Object.assign({}, rightBlockElement['data'], { text: ((_c = (_b = (_a = this.weatherData) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.municipality) && ((_f = (_e = (_d = this.weatherData) === null || _d === void 0 ? void 0 : _d.location) === null || _e === void 0 ? void 0 : _e.address) === null || _f === void 0 ? void 0 : _f.countrySubdivisionName) && ((_j = (_h = (_g = this.weatherData) === null || _g === void 0 ? void 0 : _g.location) === null || _h === void 0 ? void 0 : _h.address) === null || _j === void 0 ? void 0 : _j.countryCode)
                          ? `${(_m = (_l = (_k = this.weatherData) === null || _k === void 0 ? void 0 : _k.location) === null || _l === void 0 ? void 0 : _l.address) === null || _m === void 0 ? void 0 : _m.municipality} , ${(_q = (_p = (_o = this.weatherData) === null || _o === void 0 ? void 0 : _o.location) === null || _p === void 0 ? void 0 : _p.address) === null || _q === void 0 ? void 0 : _q.countrySubdivisionName}, ${(_t = (_s = (_r = this.weatherData) === null || _r === void 0 ? void 0 : _r.location) === null || _s === void 0 ? void 0 : _s.address) === null || _t === void 0 ? void 0 : _t.countryCode}`
                          : (_w = (_v = (_u = this.weatherData) === null || _u === void 0 ? void 0 : _u.location) === null || _v === void 0 ? void 0 : _v.address) === null || _w === void 0 ? void 0 : _w.municipality })));
                    if (rightBlockElement && rightBlockElement['name'] === 'aiba-label-description')
                      return h("aiba-label", Object.assign({}, rightBlockElement['data']));
                    if (rightBlockElement && rightBlockElement['name'] === 'aiba-weather-data-map')
                      return (_y = (_x = this.weatherData) === null || _x === void 0 ? void 0 : _x.weather) === null || _y === void 0 ? void 0 : _y.map((data) => {
                        return (h("div", { class: "weather-attributes" }, h("aiba-label", { tag: "h3", text: this.convertCamelCaseToTitleCase(data.name) }), h("aiba-label", { tag: "p", text: this.convertCamelCaseToTitleCase(data.range) })));
                      });
                  })));
              }));
          if (element && element['name'] === 'aiba-enable-form-block' && this.enableForm)
            return (element &&
              element['data'] &&
              element['data']['elements'] &&
              element['data']['elements'].map((innerElement) => {
                if (innerElement && innerElement['name'] === 'aiba-hero-image')
                  return h("aiba-hero-image", Object.assign({}, innerElement['data']));
                if (innerElement && innerElement['name'] === 'aiba-alert')
                  return h("aiba-alert", Object.assign({}, innerElement['data']));
                if (innerElement && innerElement['name'] === 'aiba-input')
                  return (h("aiba-input", Object.assign({}, innerElement['data'], { value: this.validationFieldValue, error: this.error ? this.error : null, onChange: (event) => this.handleWeatherOnChange && this.handleWeatherOnChange(event), onKeyPress: () => this.handleWeatherOnKeyPress && this.handleWeatherOnKeyPress(), onBlur: (event) => this.handleWeatherOnBlur && this.handleWeatherOnBlur(event) })));
              }));
          if (element && element['name'] === 'aiba-alert' && !this.enableForm && this.invalidPostCode)
            return h("aiba-alert", Object.assign({}, element['data']));
        })));
    };
    this.data = undefined;
    this.handlers = undefined;
    this.classes = undefined;
    this.styles = undefined;
    this.loading = false;
    this.enableForm = false;
    this.invalidPostCode = false;
    this.variation = undefined;
    this.weatherData = undefined;
    this.formError = {
      postalCode: null,
    };
    this.validationField = 'postalCode';
    this.validationFieldValue = undefined;
    this.submitButtonDisabled = true;
    this.error = undefined;
  }
  enableError(event) {
    this.error = event.detail ? event.detail : true;
  }
  render() {
    var _a, _b;
    if (typeof this.data === 'string' || typeof this.weatherData === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
      if (this.weatherData)
        this.weatherData = JSON.parse(this.weatherData);
    }
    return (h(Host, { class: this.variation ? this.variation : '' }, this.styles && h("style", null, this.styles), this.data &&
      ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.map((element) => {
        var _a, _b;
        if (element && element['name'] === 'aiba-top-block')
          return (h("div", { class: "top-block-wrapper" }, element &&
            ((_b = (_a = element.data) === null || _a === void 0 ? void 0 : _a['elements']) === null || _b === void 0 ? void 0 : _b.map((innerElement) => {
              if (innerElement && innerElement['name'] === 'aiba-label')
                return h("aiba-label", Object.assign({}, innerElement['data']));
              if (innerElement && innerElement['name'] === 'aiba-button' && this.enableForm && innerElement['tag'] === 'save')
                return (h("aiba-button", Object.assign({}, innerElement['data'], { handleClick: (event) => this.handlers.handelWeatherSave(event, this.validationFieldValue), disabled: this.submitButtonDisabled })));
              if (innerElement && innerElement['name'] === 'aiba-button' && !this.enableForm && innerElement['tag'] === 'edit')
                return h("aiba-button", Object.assign({}, innerElement['data'], { handleClick: (event) => this.handlers.handelWeatherEdit(event) }));
            }))));
        if (element && element['name'] === 'aiba-weather-data-block')
          return this.renderWeatherVariationsBlock(element['data']);
      }))));
  }
  static get is() { return "aiba-weather-block"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-weather-block.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-weather-block.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "loading": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "loading",
        "reflect": false,
        "defaultValue": "false"
      },
      "enableForm": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "enable-form",
        "reflect": false,
        "defaultValue": "false"
      },
      "invalidPostCode": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "invalid-post-code",
        "reflect": false,
        "defaultValue": "false"
      },
      "variation": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'loading' | 'enableForm' | 'invalidPostCode' | 'showWeatherData'",
          "resolved": "\"enableForm\" | \"invalidPostCode\" | \"loading\" | \"showWeatherData\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "variation",
        "reflect": false
      },
      "weatherData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "weather-data",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "formError": {},
      "validationField": {},
      "validationFieldValue": {},
      "submitButtonDisabled": {},
      "error": {}
    };
  }
  static get listeners() {
    return [{
        "name": "event-weather-input-error",
        "method": "enableError",
        "target": "window",
        "capture": true,
        "passive": false
      }];
  }
}
//# sourceMappingURL=aiba-weather-block.js.map
